<template>
  <div id="academy-page">
    <div class="visa-knowledge-banner"></div>

    <div class="center-content">
      <!-- 顶部导航 -->
      <div class="top-navs">
        <div class="nav-item" @click="goLatestNews">
          <img
            src="../../assets/imgs/homepage/nav_message.png"
            class="nav-icon"
          />
          <div class="right-box">
            <div class="nav-title">最新资讯</div>
            <div class="nav-desc">最新使馆签证政策</div>
          </div>
        </div>
        <div class="devide-line"></div>
        <div class="nav-item" @click="goCaseAnalysis">
          <img
            src="../../assets/imgs/homepage/nav_special.png"
            class="nav-icon"
          />
          <div class="right-box">
            <div class="nav-title">案例解析</div>
            <div class="nav-desc">深度解析签证专题</div>
          </div>
        </div>
        <div class="devide-line"></div>
        <div class="nav-item" @click="goVisaOpenClass">
          <img src="../../assets/imgs/homepage/nav_visa.png" class="nav-icon" />
          <div class="right-box">
            <div class="nav-title">签证公开课</div>
            <div class="nav-desc">签证知识大讲堂</div>
          </div>
        </div>
        <div class="devide-line"></div>
        <div class="nav-item" @click="goVisaGuide">
          <img
            src="../../assets/imgs/homepage/nav_guide.png"
            class="nav-icon"
          />
          <div class="right-box">
            <div class="nav-title">办签指南</div>
            <div class="nav-desc">产品使用详细说明</div>
          </div>
        </div>
      </div>

      <!-- 顶部视频 -->
      <div class="top-videos">
        <div class="first-video">
          <div class="section-header">
            <div class="section-title">一键式办签体验</div>
          </div>
          <div class="video-section">
            <video
              id="article-video"
              autoplay
              :muted="true"
              src="https://o.666visa.cn/video/ssq2020-2-28.mp4"
              :controls="true"
              height="100%"
              width="100%"
            ></video>
          </div>
        </div>
        <div class="wxa-guides">
          <div class="section-header">
            <div class="section-title">小程序办签指南</div>
            <div class="fill-space"></div>
            <div class="show-more" @click="goVisaGuide">查看更多</div>
          </div>
          <wxa-visa-guides :guide-videos="guideVideos"></wxa-visa-guides>
        </div>
      </div>

      <!-- 签证公开课 -->
      <div class="visa-open-classes">
        <div class="section-header">
          <div class="section-title">签证公开课</div>
          <div class="open-classes-navs">
            <div
              class="class-nav-item"
              v-for="(claszType, index) in openClassVideos"
              :key="claszType.type_id"
              :class="{ active: currentClaszIndex === index }"
              @click="currentClaszIndex = index"
            >
              {{ claszType.type_name }}
            </div>
          </div>
          <div class="fill-space"></div>
          <div class="show-more" @click="goVisaOpenClass">查看更多</div>
        </div>
        <div class="videos-box" v-if="openClassVideos[currentClaszIndex]">
          <visa-video-item
            v-for="clasz in openClassVideos[currentClaszIndex].type_arr"
            :key="clasz.id"
            :videoInfo="clasz"
          ></visa-video-item>
        </div>
      </div>

      <!-- 最新资讯 -->
      <div class="lastest-news">
        <div class="section-header">
          <div class="section-title">最新资讯</div>
          <div class="fill-space"></div>
          <div class="show-more" @click="goLatestNews">查看更多</div>
        </div>
        <div class="news-box">
          <visa-news-item
            v-for="news in visaNews"
            :key="news.id"
            :news-info="news"
          ></visa-news-item>
        </div>
      </div>

      <!-- 案例解析 -->
      <div class="case-analysis">
        <div class="section-header">
          <div class="section-title">案例解析</div>
          <div class="fill-space"></div>
          <div class="show-more" @click="goCaseAnalysis">查看更多</div>
        </div>
        <div class="cases-box">
          <visa-case-item
            v-for="caseItem in caseArticles"
            :case-info="caseItem"
            :key="caseItem.id"
          ></visa-case-item>
        </div>
      </div>
    </div>

    <!-- 收藏 -->
    <favorite-page></favorite-page>
  </div>
</template>

<script>
import sensorsdata from "sa-sdk-javascript";
import User from "../../libs/user";
import favoritePage from "./components/favorite-page";
import visaVideoItem from "./components/visa-video-item";
import visaNewsItem from "./components/visa-news-item";
import visaCaseItem from "./components/visa-case-item";
import wxaVisaGuides from "./components/wxa-visa-guides";
import knowledgeService from "../../services/knowledge-service";
import utils from "../../libs/utils";

export default {
  name: "academy-page",
  components: {
    favoritePage,
    visaVideoItem,
    visaNewsItem,
    visaCaseItem,
    wxaVisaGuides,
  },
  data() {
    return {
      User,
      homepageData: {},
      guideVideos: [],
      openClassVideos: [],
      currentClaszIndex: 0,
      visaNews: [],
      caseArticles: [],
    };
  },
  computed: {},
  methods: {
    goLatestNews() {
      this.$router.push({ name: "latestNews" });
    },

    goCaseAnalysis() {
      this.$router.push({ name: "caseAnalysis" });
    },

    goVisaOpenClass() {
      this.$router.push({ name: "visaOpenClass" });
    },

    goVisaGuide() {
      this.$router.push({ name: "visaGuide" });
    },

    getPageData() {
      knowledgeService.getVisaKnowledgeHomepage().then((data) => {
        this.homepageData = data;
        this.guideVideos = knowledgeService.formatGuideVideos(
          data.video.guide_video
        );
        this.openClassVideos = knowledgeService.formatVisaOpenClasses(
          data.video.curse_video
        );
        this.visaNews = data.article.new_article;
        this.caseArticles = data.article.case_article;
      });
    },
  },
  created() {
    sensorsdata.track("Enter_the_insurance_mall", {});
    this.getPageData();
  },
};
</script>

<style lang="less">
#academy-page {
  background-color: white;
  .visa-knowledge-banner {
    width: 100%;
    height: 280px;
    background: #2842e6;
    background-image: url("../../assets/imgs/acadmy/banner.png");
    background-position: center center;
    background-repeat: no-repeat;
    background-size: 1920px 280px;
  }
  .center-content {
    width: 1120px;
    margin: 0 auto;
    .fill-space {
      flex: 1;
    }
    .section-header {
      display: flex;
      align-items: center;
      width: 100%;
      .section-title {
        font-size: 24px;
        font-weight: 600;
        color: #2f333d;
        line-height: 26px;
        position: relative;
        &::after {
          content: "";
          width: 96px;
          height: 8px;
          background: linear-gradient(
            270deg,
            rgba(89, 159, 255, 0) 0%,
            #599fff 100%
          );
          opacity: 0.6;
          position: absolute;
          left: 0;
          bottom: -4px;
        }
      }
      .show-more {
        display: flex;
        align-items: center;
        font-size: 14px;
        font-weight: 400;
        color: #444444;
        line-height: 16px;
        cursor: pointer;
        &::after {
          content: "";
          background-image: url("../../assets/imgs/acadmy/right-enter.png");
          background-size: 100% 100%;
          width: 12px;
          height: 12px;
        }
      }
    }
    .top-navs {
      width: 1120px;
      height: 80px;
      background: #ffffff;
      box-shadow: 0px 4px 6px 0px rgba(47, 51, 61, 0.06);
      border-radius: 4px;
      display: flex;
      align-items: center;
      margin-top: -20px;
      .nav-item {
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        flex: 1;
        .nav-icon {
          width: 42px;
          height: 42px;
        }
        .right-box {
          display: flex;
          flex-direction: column;
          margin-left: 12px;
          .nav-title {
            font-size: 16px;
            font-weight: 600;
            color: #2f333d;
            line-height: 18px;
          }
          .nav-desc {
            font-size: 12px;
            font-weight: 400;
            color: #5f666e;
            line-height: 17px;
            margin-top: 6px;
          }
        }
        &:hover {
          .nav-title {
            color: #599fff;
          }
          .nav-desc {
            color: #599fff;
          }
        }
      }
      .devide-line {
        width: 1px;
        height: 32px;
        background: #e9eef2;
        border-radius: 0px;
      }
    }
    .top-videos {
      display: flex;
      margin-top: 48px;
      .first-video {
        .video-section {
          margin-top: 28px;
          width: 615px;
          height: 346px;
        }
      }
      .wxa-guides {
        margin-left: 30px;
        flex: 1;
        display: flex;
        flex-direction: column;
        align-items: center;
      }
    }
    .visa-open-classes {
      margin-top: 48px;
      .section-header {
        .open-classes-navs {
          margin-left: 32px;
          display: flex;
          .class-nav-item {
            cursor: pointer;
            margin-left: 24px;
            font-size: 14px;
            font-weight: 400;
            color: #2f333d;
            line-height: 14px;
            position: relative;
            &:first-child {
              margin-left: 0;
            }
            &:hover,
            &.active {
              color: #599fff;
              font-weight: 600;
              &::after {
                content: "";
                width: 20px;
                height: 2px;
                background: #599fff;
                border-radius: 2px;
                position: absolute;
                left: 50%;
                bottom: -8px;
                transform: translateX(-50%);
              }
            }
          }
        }
      }
      .videos-box {
        margin-top: 24px;
        display: flex;
        flex-wrap: wrap;
      }
    }
    .lastest-news {
      margin-top: 34px;
      .news-box {
        margin-top: 4px;
      }
    }
    .case-analysis {
      margin-top: 48px;
      .cases-box {
        margin-top: 32px;
        display: flex;
        flex-wrap: wrap;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/academy/Academy.vue